module.exports = __webpack_public_path__ + "static/media/voucher.4a93a451.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/voucher.svg
// module id = 746
// module chunks = 21